import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "~/components/ui/popover.jsx";
import { Button } from "~/components/ui/button.jsx";
import { router } from "@inertiajs/react";
import { Badge } from "~/components/ui/badge.jsx";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "~/components/ui/drawer.jsx";
import ProductPropertyFilter from "@/components/products/ProductPropertyFilter.jsx";
import * as reactUse from "react-use";
import { ChevronDown, ListFilterPlus } from "lucide-react";

const {useMedia} = reactUse;


export default function ({ productPropertyFilter, onValuesChange }) {
  if (import.meta.env.SSR) return null;

  const params = new URLSearchParams(document.location.search);
  const filterKey = `filter[properties][${productPropertyFilter.name}]`;
  const count = params.get(filterKey)?.split(",").length || 0;

  const props = {
    productPropertyFilter,
    filterKey,
    count,
    onValuesChange
  }

  const isDesktop = useMedia("(width >= 64rem)");

  return (
    <div>
      {isDesktop && (
        <OpenInPopover {...props} />
      )}
      {!isDesktop && (
        <OpenInDrawer {...props} />
      )}
    </div>
  );
}

function OpenInPopover({ productPropertyFilter, count, onValuesChange }) {
  return (
    <Popover>
      <PopoverTrigger asChild className="group">
        <Button className="font-normal px-4" variant={"outline"} size="xl">
          <ListFilterPlus />
          <span>{productPropertyFilter.presentation}</span>
          <FiltersCounter count={count}/>
          <ChevronDown className="group-data-[state=open]:rotate-180 transition duration-300" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="">
        <ProductPropertyFilter
          productPropertyFilter={productPropertyFilter}
          onValuesChange={onValuesChange}
        />
      </PopoverContent>
    </Popover>
  );
}

function OpenInDrawer({ productPropertyFilter, count, onValuesChange }) {
  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button className="font-normal shadow-none" variant={"outline"}>
          <span>{productPropertyFilter.presentation}</span>
          <FiltersCounter count={count} />
          <ChevronDown />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="h-full mx-auto w-full max-w-sm px-7">
        {/* <DrawerHeader>
          <DrawerTitle>{productPropertyFilter.presentation}</DrawerTitle>
          <DrawerDescription className="">
            This action cannot be undone.
          </DrawerDescription>
        </DrawerHeader> */}

        <div className="py-8">
          <ProductPropertyFilter productPropertyFilter={productPropertyFilter} onValuesChange={onValuesChange} />
        </div>
        
        <DrawerFooter className="hidden">
          <Button>Submit</Button>
          <DrawerClose>
            <Button variant="outline">Cancel</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}

function FiltersCounter ({count}) {
  if(count === 0) return null;
  return <Badge className="h-5 max-w-5">{count}</Badge>
}
